// extracted by mini-css-extract-plugin
export default {"fi":"fi","fi_html":"fi_html","fi_textarea":"fi_textarea","fi_label":"fi_label","fi_toolbar":"fi_toolbar","fi_btn_switch":"fi_btn_switch"};